import { Button, Dialog } from './ui';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * A reusable confirmation modal for user actions.
 */
export function ConfirmationModal({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}: ConfirmationModalProps): React.JSX.Element | null {
  return (
    <Dialog isOpen={isOpen} onClose={onCancel} title={title} size="md">
      <p className="text-gray-600 mb-6">{message}</p>
      <div className="flex justify-end gap-3">
        <Button onClick={onCancel} variant="secondary">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} variant="primary">
          {confirmText}
        </Button>
      </div>
    </Dialog>
  );
}
